import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './index.scss'
import logo from '../../static/report/logo.png'
import backPng from '../../static/head/back.png'
import homePng from '../../static/head/home.png'
const MHead = () => {
  let navigate = useNavigate()

  let goHome = () => {
    navigate(`/rlb/YearMiddleReport2024/1`)
  }

  let goback = () => {
    if (window.location.href.indexOf('/detail') != -1) {
      navigate(`/rlb/YearMiddleReport2024/1`)
    } else {
      navigate(-1)
    }
  }

  return (
    <div className="head">
      <img src={logo} alt="logo" onClick={goHome} />
      <div>
        <img src={backPng} alt="logo" onClick={goback} />
        <img src={homePng} alt="logo" onClick={goHome} />
      </div>
      {/* <div onClick={goMineReport}>
              <img src={myReportPng} alt="myReportPng" />
              <p>我的报告</p>
            </div> */}
    </div>
  )
}

export default MHead
